import BliButton from '@blibli/blue.button/dist/button/blue/Button'
import BliModal from '@blibli/blue.modal/dist/modal/blue/Modal'
import BliModalHeader from '@blibli/blue.modal/dist/modal/blue/ModalHeader'
import BliModalBody from '@blibli/blue.modal/dist/modal/blue/ModalBody'
import BliModalFooter from '@blibli/blue.modal/dist/modal/blue/ModalFooter'
import BliIconSiUspCustomerCare from '@blibli/blue-dls-library-icon/dist/UspCustomerCare'
import constants from '@vue3/constants'
import APPROVAL_PENDING_IMAGE from '@vue3/assets/images/registration-waiting.svg'
import APPROVED_IMAGE from '@vue3/assets/images/registration-approved.svg'
import { mapState, mapActions } from 'pinia'
import CommonMixin from '@vue3/mixins/commonMixin.js'
import AuthStore from '@vue3/store/auth-store.js'
import RegistrationStore from '@vue3/store/registration-store.js'
import { app } from '@vue3/configs'

const { APPROVAL_PENDING } = constants.companyRegistrationStatus

export default {
  name: 'RegistrationStatusModal',
  components: {
    BliModal,
    BliButton,
    BliModalBody,
    BliModalFooter,
    BliModalHeader,
    BliIconSiUspCustomerCare
  },
  data () {
    return {
      isFirstVisitCompleted: false,
      showButtonLoader: false
    }
  },
  mixins: [CommonMixin],
  computed: {
    ...mapState(AuthStore, ['isLoggedIn']),
    modalDetails () {
      return {
        title: this.$t(`login.${this.registrationStatus}.title`),
        description: this.$t(`login.${this.registrationStatus}.description`),
        helperText: this.$t(`login.${this.registrationStatus}.helper`),
        button: this.$t(`login.${this.registrationStatus}.buttonText`),
        imageSrc: this.isApprovalPending ? APPROVAL_PENDING_IMAGE : APPROVED_IMAGE
      }
    },
    isModalVisible () {
      return this.isLoggedIn && (this.isApprovalPending || this.currentCompanyInfo?.firstLoginPostApproval)
    },
    companyDetails () {
      return this.userDetails?.companyDetails
    },
    registrationStatus () {
      return this.companyDetails?.companyRegistrationStatus || ''
    },
    isApprovalPending () {
      return this.registrationStatus === APPROVAL_PENDING
    }
  },
  methods: {
    ...mapActions(RegistrationStore, ['firstLoginPostApproval']),
    ...mapActions(AuthStore, ['setFirstLoginApproval']),
    handleAction () {
      if (this.showButtonLoader) {
        return
      }
      if (this.isApprovalPending) {
        return this.handleApprovalPending()
      }
      this.firstLoginPostApproval({
        success: this.firstLoginPostApprovalSuccessAndFailure,
        fail: this.firstLoginPostApprovalSuccessAndFailure
      })
    },
    handleApprovalPending () {
      if (this.isUserMappedWithSingleTenant) {
        this.showButtonLoader = true
        this.handleLogoutUser()
      } else {
        this.setShowTenantPickerModal({
          showModal: true,
          isTenantAlreadySelected: false
        })
      }
    },
    handleLogoutUser () {
      this.logoutUser({
        success: this.handleLogoutUserSuccess
      })
    },
    handleLogoutUserSuccess () {
      this.$router.push({ name: app.routerName.login })
      if (!this.isIOSApp) {
        return
      }
      this.postMessageToIOSListener('LOGGED_OUT')
    },
    firstLoginPostApprovalSuccessAndFailure () {
      this.showButtonLoader = false
      this.setFirstLoginApproval(false)
      this.isFirstVisitCompleted = true
    }
  }
}
